module.exports = __webpack_public_path__ + "static/img/4.7dd2ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/hjzz/4.png
// module id = Wq4d
// module chunks = 1